const state = {
  traceTokens: null
}

const getters = {
  traceTokens: state => state.traceTokens
}

const mutations = {
  SET_TRACE_TOKENS (state, traceTokens) {
    state.traceTokens = traceTokens
  }
}

export default {
  state,
  getters,
  mutations
}
